module.exports = __webpack_public_path__ + "media/images/minci-2abf8022a5b51571dbe55b37b39397cb.png";